import * as serviceRate from './serviceRate';
import * as iccServiceRate from './icc';

const reducers = {
  ...serviceRate,
  ...iccServiceRate,
};

export default reducers;
